/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { N200 } from '@atlaskit/theme/colors';

interface SearchButtonProps {
  onClick?(): void;
}

const searchIconStyles = css({
  color: token('color.icon', N200),
});

const SearchButton = ({ onClick }: SearchButtonProps) => {
  return (
    <Button
      onClick={onClick}
      iconBefore={
        <span css={searchIconStyles}>
          <SearchIcon label="" />
        </span>
      }
      appearance="subtle"
    >
      Search
    </Button>
  );
};

export default SearchButton;
